var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'core', 'model/file', 'component/document-viewer', 'app-common/component/loader', 'app-common/component/confirm-dialog', 'component/document-uploader', 'template/document-entry/viewer-bk.htm', 'template/document-entry/uploader.htm', 'template/document-entry/tabular.htm'], function($, _, core, FileModel, DocumentViewer, loader, confirmDialog, documentUploader, viewerTemplate, uploaderTemplate, tabularTemplate) {
  var BkDocumentViewer;
  return BkDocumentViewer = (function(_super) {

    __extends(BkDocumentViewer, _super);

    function BkDocumentViewer() {
      BkDocumentViewer.__super__.constructor.apply(this, arguments);
    }

    BkDocumentViewer.prototype.events = function() {
      return _.extend({}, DocumentViewer.prototype.events, {
        'click .editing': 'toggleEditMenu',
        'click .zoom_original': 'zoomOriginal',
        'click .zoom_fit': 'zoomFit',
        'click .rotate_left': 'rotateLeft',
        'click .rotate_right': 'rotateRight',
        'click .upload-tabular-file': 'download',
        'click .download-splitted': 'downloadSplitedByPagesDocument',
        'click .insert-page': 'showInsertPage',
        'click .insert-before': 'insertBefore',
        'click .insert-after': 'insertAfter',
        'click .delete-page:not(.disabled)': 'deleteCurrentPage',
        'click .delete-document': 'deleteFile'
      });
    };

    BkDocumentViewer.prototype.codes = {
      numpadMinusKey: 109,
      dashKey: 189,
      eKey: 69,
      deleteKey: 46,
      backspaceKey: 8
    };

    BkDocumentViewer.prototype.template = viewerTemplate;

    BkDocumentViewer.prototype.fullscreen = false;

    BkDocumentViewer.prototype.fileList = [];

    BkDocumentViewer.prototype.initialize = function(options) {
      return BkDocumentViewer.__super__.initialize.apply(this, arguments);
    };

    BkDocumentViewer.prototype.render = function(model, page) {
      var _ref;
      this.model = model;
      if (page == null) {
        page = 0;
      }
      if (((_ref = this.model.get('file')) != null ? _ref.get('tabular') : void 0) === true) {
        return this.showTabularUI();
      } else if (this.getImages().length === 0) {
        return this.showDocumentCreation();
      } else {
        return BkDocumentViewer.__super__.render.apply(this, arguments);
      }
    };

    BkDocumentViewer.prototype.showTabularUI = function() {
      return this.$el.html(tabularTemplate);
    };

    BkDocumentViewer.prototype.onRenderFinish = function() {
      if (this.getImages().length === 1) {
        return this.$el.find('.delete-page').addClass('disabled');
      } else {
        return this.$el.find('.delete-page').removeClass('disabled');
      }
    };

    BkDocumentViewer.prototype.setupShortCuts = function() {
      var _this = this;
      $(window).off('keydown.viewer');
      return $(window).on('keydown.viewer', function(e) {
        var code;
        code = e.which || e.keyCode;
        if ((code === _this.codes.numpadMinusKey || code === _this.codes.dashKey) && e.ctrlKey && _this.getImages().length > 1) {
          _this.deleteCurrentPage();
        }
        if ((code === _this.codes.eKey) && e.ctrlKey && e.shiftKey) {
          _this.toggleEditMenu();
        }
        if ((code === _this.codes.deleteKey || code === _this.codes.backspaceKey) && e.ctrlKey && !e.shiftKey) {
          return _this.deleteFile();
        }
      });
    };

    BkDocumentViewer.prototype.updatePage = function(current, all) {
      return this.$el.find('.paginate').text("Page " + current + "/" + all);
    };

    BkDocumentViewer.prototype.zoomTo = function(value) {
      return this.$el.find('.viewer').smoothZoom('focusTo', {
        zoom: value,
        x: 0,
        y: 0
      });
    };

    BkDocumentViewer.prototype.zoomOriginal = function() {
      var originalWidth, ratio;
      originalWidth = this.$el.find('.viewer > img')[0].naturalWidth;
      if (originalWidth) {
        ratio = originalWidth * 100 / this.$el.width();
        return this.zoomTo(Math.round(ratio));
      } else {
        return this.zoomFit();
      }
    };

    BkDocumentViewer.prototype.zoomFit = function() {
      return this.zoomTo(100);
    };

    BkDocumentViewer.prototype.rotateLeft = function() {
      return this.rotatePage('left');
    };

    BkDocumentViewer.prototype.rotateRight = function() {
      return this.rotatePage('right');
    };

    BkDocumentViewer.prototype.rotatePage = function(orientation) {
      var promise,
        _this = this;
      loader.init({
        spinnerContainer: this.$el
      });
      promise = this.model.get('file').rotatePage(this.page + 1, orientation).then(function() {
        return _this.model.get('file').fetch();
      });
      promise.always(function() {
        return loader.hide();
      });
      return promise.done(function() {
        return _this.render(_this.model, _this.page);
      });
    };

    BkDocumentViewer.prototype.toggleEditMenu = function() {
      this.$el.find('.editing').toggleClass('active');
      return this.$el.find('.controls-editing').toggle();
    };

    BkDocumentViewer.prototype.showDocumentCreation = function() {
      var updateDocument,
        _this = this;
      this.$el.html('<div id="create-document"></div>');
      updateDocument = function(file) {
        var promise;
        _this.model.set('fileId', file.get('id'));
        _this.model.set('file', file);
        if (_this.model.isNew()) {
          loader.hide();
          return _this.render(_this.model);
        } else {
          promise = _this.model.save();
          promise.always(function() {
            return loader.hide();
          });
          return promise.done(function() {
            return _this.render(_this.model);
          });
        }
      };
      return documentUploader.initUploader({
        container: $('#create-document')[0],
        params: {
          uploadContext: 'document-entry',
          clientId: core.getCurrentClientId()
        },
        template: uploaderTemplate,
        onSubmit: function() {
          loader.init({
            spinnerContainer: _this.$el
          });
          return _this.fileList = [];
        },
        onComplete: function(id, fileName, response) {
          var file, promise;
          file = _this.createFile(response.result);
          promise = file.fetch();
          promise.fail(function() {
            return loader.hide();
          });
          return promise.done(function() {
            var insertPromise;
            if (_this.fileList.length > 0) {
              insertPromise = _this.fileList[0].insertPage(file.id, 9999, 'after').then(function() {
                return _this.fileList[0].fetch();
              });
              insertPromise.done(function() {
                return _this.render(_this.model, 0);
              });
            }
            _this.fileList.push(file);
            return updateDocument(_this.fileList[0]);
          });
        }
      });
    };

    BkDocumentViewer.prototype.createFile = function(fileId) {
      return new FileModel({
        id: fileId
      });
    };

    BkDocumentViewer.prototype.showInsertPage = function() {
      this.$el.find('.insert-page').toggleClass('active');
      return this.$el.find('.insert-menu').toggle();
    };

    BkDocumentViewer.prototype.insertBefore = function() {
      return this.insertPage('before');
    };

    BkDocumentViewer.prototype.insertAfter = function() {
      return this.insertPage('after');
    };

    /*
    # Use hidden uploader
    */


    BkDocumentViewer.prototype.insertPage = function(position) {
      var uploader,
        _this = this;
      uploader = this.$el.find('.uploader');
      documentUploader.initUploader({
        multiple: true,
        container: uploader[0],
        params: {
          uploadContext: 'document-entry',
          clientId: core.getCurrentClientId()
        },
        onSubmit: function() {
          return loader.init({
            spinnerContainer: _this.$el
          });
        },
        onComplete: function(id, fileName, response) {
          var file, filePromise;
          file = _this.createFile(response.result);
          filePromise = file.fetch();
          filePromise.fail(function() {
            return loader.hide();
          });
          return filePromise.done(function(insertedFile) {
            var insertPromise;
            insertPromise = _this.model.get('file').insertPage(insertedFile.id, _this.page + 1, position).then(function() {
              return _this.model.get('file').fetch();
            });
            insertPromise.always(function() {
              return loader.hide();
            });
            return insertPromise.done(function() {
              return _this.render(_this.model, position === 'before' ? _this.page + 1 : _this.page);
            });
          });
        }
      });
      return uploader.find('input[type="file"]').click();
    };

    BkDocumentViewer.prototype.deleteCurrentPage = function() {
      var _this = this;
      confirmDialog.init('Are you sure?', {
        ok: 'Ok',
        cancel: 'Cancel'
      }, true);
      return $('#confirm-dialog').on('click', function() {
        var promise;
        confirmDialog.hide();
        loader.init({
          spinnerContainer: _this.$el
        });
        promise = _this.model.get('file').deletePage(_this.page + 1).then(function() {
          return _this.model.get('file').fetch();
        });
        promise.always(function() {
          return loader.hide();
        });
        return promise.done(function() {
          var newPage;
          newPage = _this.page - 1;
          if (newPage < 0) {
            newPage = 0;
          }
          return _this.render(_this.model, newPage);
        });
      });
    };

    BkDocumentViewer.prototype.deleteFile = function() {
      var _this = this;
      confirmDialog.init('Are you sure?', {
        ok: 'Ok',
        cancel: 'Cancel'
      }, true);
      return $('#confirm-dialog').on('click', function() {
        var promise;
        confirmDialog.hide();
        loader.init({
          spinnerContainer: _this.$el
        });
        promise = _this.model.deleteFile();
        promise.always(function() {
          return loader.hide();
        });
        return promise.done(function() {
          return _this.render(_this.model);
        });
      });
    };

    BkDocumentViewer.prototype.downloadSplitedByPagesDocument = function() {
      return this.model.get('file').downloadSplittedPages();
    };

    return BkDocumentViewer;

  })(DocumentViewer);
});
